<template>
  <div class="headerCtn" :class="{ 'animation': homeFlag || headerShow, 'headerShow': headerShow }"
    @mouseleave="headerShow = false">
    <div class="main">
      <div class="leftLogo">
        <img class="logo" :src="homeFlag ? logoSpecial : logo" />
      </div>
      <div class="rightNav">
        <div class="title" :class="{ 'active': nowPage === '首页' }" @click="$router.push('/home')">
          首页
          <div class="line"></div>
        </div>
        <div class="title" :class="{ 'active': nowPage === '关于我们' }" @click="$router.push('/about')">
          关于我们
          <div class="line"></div>
        </div>
        <div class="title" :class="{ 'active': nowPage === '项目案例' }" @click="$router.push('/anli')">
          项目案例
          <div class="line"></div>
        </div>
        <div class="title" :class="{ 'active': nowPage === '新闻中心' }" @click="$router.push('/news')">
          新闻中心
          <div class="line"></div>
        </div>
        <div class="title" :class="{ 'active': nowPage === '投资者关系' }" @click="$router.replace('/fuwu')">
          投资者关系
          <div class="line"></div>
        </div>
        <div class="title" :class="{ 'active': nowPage === '联系我们' }" @click="$router.push('/contact')">
          联系我们
          <div class="line"></div>
        </div>
        <div class="title phone">
          <i class="el-icon-phone-outline"></i> 0571-85371190
        </div>
      </div>
    </div>
    <div class="navCtn">
      <div class="navMain">
        <div class="navTitle">{{ title }}</div>
        <div class="navList">
          <div class="nav" v-for="item in navList" :key="item.name" @click="$router.push(item.url)">{{ item.name }}
            <i class="el-icon-arrow-right" style="margin-left: 22px;font-size: 14px;"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homeFlag: {
      default: true
    },
    nowPage: {
      default: ''
    }
  },
  data() {
    return {
      logoSpecial: require('@/assets/images/logo.png'),
      logo: require('@/assets/images/logo.png'),
      headerShow: false,
      title: '关于我们',
      navList: []
    }
  },
  methods: {
    showHeader(title) {
      this.headerShow = true
      this.title = title
      this.navList = {
        '关于我们': [{
          url: '/about',
          name: '企业介绍'
        },
        // {
        //   url: '',
        //   name: '董事长寄语'
        // }, {
        //   url: '',
        //   name: '发展历程'
        // },
        {
          url: '',
          name: '企业文化'
        },
          // {
          //   url: '',
          //   name: '组织架构'
          // }, {
          //   url: '',
          //   name: '荣誉资质'
          // }
        ],
        '项目案例': [{
          url: '/productA',
          name: '案例一'
        }, {
          url: '/productB',
          name: '案例二'
        }, {
          url: '/productC',
          name: '案例三'
        }],
        '新闻中心': [{
          url: '',
          name: '公司新闻'
        }, {
          url: '',
          name: '视频中心'
        }, {
          url: '',
          name: '公告'
        }]
      }[title]
    }
  }
}
</script>

<style lang="scss" scoped>
.headerCtn {
  position: fixed;
  max-height: 100px;
  background: rgba(255, 255, 255, 1);
  left: 0;
  right: 0;
  z-index: 99;
  color: rgba(0, 0, 0, .8);
  overflow: hidden;
  transition: 0.2s linear;

  &.headerShow {
    max-height: 360px;

    .nav {
      transform: translateX(0) !important;
      opacity: 1 !important;
    }
  }

  &.animation {
    background: #fff;
    color: #333;
    box-shadow: 0px 0px 10px rgba(15, 91, 183, 0.1);
  }

  .main {
    min-width: 1200px;
    width: calc(100vw - 540px);
    margin: auto;
    min-height: 100px;
    display: flex;
    justify-content: space-between;

    .leftLogo {
      height: 100px;
      display: flex;
      align-items: center;

      .logo {
        // width: 60px;
        height: 72px;
        // margin-right: 12px;
      }

      .name {
        .span1 {
          font-size: 32px;
          letter-spacing: 2px;
        }

        .span2 {
          font-size: 24px;
        }
      }
    }

    .rightNav {
      font-size: 18px;
      display: flex;
      align-items: center;

      .title {
        position: relative;
        cursor: pointer;
        margin-left: 40px;

        &.phone {
          cursor: text;
        }

        &:hover:not(.phone) {
          color: #009BFB;

          .line {
            left: 6px;
            right: 6px;
          }
        }

        &.active {
          color: #009BFB;

          .line {
            left: 6px;
            right: 6px;
          }
        }

        .line {
          position: absolute;
          height: 4px;
          background: #009BFB;
          left: 50%;
          right: 50%;
          bottom: -10px;
          border-radius: 2px;
          margin: auto;
          transition: 0.25s linear;
        }
      }
    }
  }

  .navCtn {
    width: calc(100vw - 540px);
    min-width: 1200px;
    overflow: hidden;
    margin: auto;

    .navMain {
      width: 991px;
      float: right;
      margin-bottom: 22px;
      padding-left: 60px;
      box-sizing: border-box;
    }

    .navTitle {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }

    .navList {
      font-size: 16px;
      display: flex;
      margin: 22px 0;

      .nav {
        cursor: pointer;
        line-height: 36px;
        text-align: left;
        border-bottom: 1px solid #ccc;
        color: #444;
        margin-right: 42px;

        &:hover {
          color: #009BFB;
          border-color: #009BFB;
        }
      }
    }
  }
}
</style>